import { useCallback, useMemo, useState } from 'react';
import * as S from './styles';
import { colors } from '@/constants';
import { BarCode } from '..';
const SearchSVG = `${process.env.PUBLIC_URL}/fi_search.svg`;
const SearchFillSVG = `${process.env.PUBLIC_URL}/fi_search_fill.svg`;
interface Props {
  id: string;
  value: string;
  placeholder?: string;
  onFocus?: (s?: any) => void;
  setInput: (s: any) => void;
  showCamera?: boolean;
  showMicrophone?: boolean;
  backgroundColor?: string;
  isExactSearch?: boolean;
  setIsExactSearch?: (s: boolean) => void;
}

const PLACEHOLDER_LIST = [
  'Café',
  'Cerveja',
  'Leite',
  'Leite Condensado',
  'Detergente',
  'Achocolatado',
  'Esmalte',
  'Shampoo',
  'Condicionador',
  'Biscoito',
];

const Search = ({
  id,
  value,
  onFocus,
  isExactSearch,
  setIsExactSearch,
  setInput,
  backgroundColor,
  showCamera = true,
  showMicrophone = true,
  placeholder: propPlaceholder,
}: Props) => {
  const placeholder = useMemo(() => {
    const firstProduct = PLACEHOLDER_LIST[Math.floor(Math.random() * PLACEHOLDER_LIST.length)];
    const secondProduct = PLACEHOLDER_LIST[Math.floor(Math.random() * PLACEHOLDER_LIST.length)];
    return propPlaceholder || `Busque por ${firstProduct}, ${secondProduct}...`;
  }, []);
  
  const win: any = window;
  const [isSpeaking, setIsSpeaking] = useState(false);

  const recognition = useMemo(() => {
    const Speech =
      win?.SpeechRecognition || win?.webkitSpeechRecognition || win?.mozSpeechRecognition || win?.msSpeechRecognition;
    const recognit = Speech ? new Speech() : null;
    if (recognit) {
      recognit.lang = 'pt-BR';

      recognit.onstart = () => {
        onFocus ? onFocus() : setIsSpeaking(true);
      };

      recognit.onresult = (event: any) => {
        const transcript = event.results?.[0]?.[0]?.transcript;
        setInput(transcript);
      };

      recognit.onend = () => {
        setIsSpeaking(false);
      };
    }

    return recognit;
  }, [win, onFocus, setInput]);

  const speech = useCallback(() => {
    recognition?.start();
  }, [recognition]);

  return (
    <S.InputContent $backgroundColor={backgroundColor}>
      {!setIsExactSearch && <S.Search size={26} color={colors.gray.gray60} />}
      {setIsExactSearch && (
        <S.SearchContent onClick={() => setIsExactSearch(!isExactSearch)}>
          <S.EspecialSearchContent $isSpecialSearch={!!isExactSearch}>
            <S.SearchIcon src={isExactSearch ? SearchFillSVG : SearchSVG} alt="search" />
          </S.EspecialSearchContent>

          {isExactSearch && <S.EspecialSearchText>Exata</S.EspecialSearchText>}
        </S.SearchContent>
      )}

      <S.Input
        type="text"
        value={value}
        id="field-search"
        onFocus={onFocus}
        className="form-control"
        placeholder={placeholder}
        data-test={`component-search-input-${id}`}
        onChange={(e) => setInput(e.target.value)}
      />

      {showCamera && <BarCode handleClick={onFocus} handleFilter={setInput} />}

      {showMicrophone && (
        <S.Button>
          <S.OutlineMicrophone
            size={20}
            style={{ marginLeft: 5 }}
            color={isSpeaking ? colors.brand.red : colors.gray.gray60}
            onClick={() => (onFocus ? onFocus() : !isSpeaking && speech())}
          />
        </S.Button>
      )}
    </S.InputContent>
  );
};

export default Search;
